<template>
  <base-material-card
    color="indigo"
    icon="mdi-view-grid-plus"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
        />
      </v-col>
    </v-row>

    <v-divider class="mt-3" />

    <v-data-table
      :headers="localizationHeaders"
      :items="items"
      :search.sync="search"
      :sort-by="['name']"
      :sort-desc="[false]"
      :loading="loading"
    >
      <template v-slot:top>
        <v-row>
          <v-col
            md="8"
            sm="2"
          >
            <v-text-field
              v-model="gameExpansionName"
              color="secondary"
              :label="$t('fields.gameExpansion.name')"
              outlined
            />
          </v-col>
          <v-col
            md="4"
            sm="2"
          >
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addgameExpansion"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.name`]="props">
        <v-edit-dialog
          :return-value.sync="props.item.name"
          @save="editgameExpansion(props.item)"
        >
          {{ props.item.name }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.name"
              :rules="[max50chars]"
              label="Edit"
              single-line
              counter
            />
          </template>
        </v-edit-dialog>
      </template>
    </v-data-table>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </base-material-card>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const gameExpansionsRepository = repositoryFactory.get('gameExpansions')

  export default {
    name: 'GameExpansionList',
    props: {
      gameLineId: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      items: [],
      gameExpansionName: '',
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      max50chars: v => v.length <= 25 || 'El nombre no puede exceder 50 carácteres',
    }),
    computed: {
      title: {
        get () {
          return this.$t('gameExpansions')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.gameExpansion.name'),
            value: 'name',
          },
        ]
      },
    },
    mounted () {
      this.fecthData()
    },
    methods: {
      fecthData () {
        var self = this
        self.loading = true
        gameExpansionsRepository.getByGame(self.gameLineId).then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      addgameExpansion () {
        var self = this
        if (!self.gameExpansionName) {
          return
        }
        var data = {
          data: { name: self.gameExpansionName, gameLineId: self.gameLineId },
        }
        self.loadingSave = true
        gameExpansionsRepository.addgameExpansion(data).then(response => {
          if (response.data.isValid) {
            self.gameExpansionName = ''
            self.fecthData()
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loadingSave = false
        }).catch(err => {
          self.errorMessage = err
          self.showErrorMessage = true
          self.loadingSave = false
        })
      },
      editgameExpansion  (item) {
        var self = this
        var data = {
          data: { name: item.name, id: item.id, gameLineId: item.gameLineId },
        }
        self.loadingSave = true
        gameExpansionsRepository.updategameExpansion(data, item.id).then(response => {
          if (response.data.isValid) {

          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loadingSave = false
        }).catch(err => {
          self.errorMessage = err
          self.showErrorMessage = true
          self.loadingSave = false
        })
      },
    },
  }
</script>
